import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CashbackPopupComponent } from './cashback-popup.component';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SidebarModule } from 'primeng/sidebar';


@NgModule({
  declarations: [
    CashbackPopupComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    OverlayPanelModule,
    SidebarModule,
  ],
  exports: [
    CashbackPopupComponent
  ]
})
export class CashbackPopupModule { }
